import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useNavigate } from "react-router-dom";
import { ArrowRight, FileText } from "lucide-react";
const Awards = () => {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 rtl">
      {/* Header */}
      <div className="relative overflow-hidden min-h-[40vh] flex items-center">
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-gradient-to-br from-cyan-100 via-cyan-200 to-teal-200"></div>
          <div className="absolute inset-0 opacity-25">
            <div className="absolute top-20 left-20 w-96 h-96 bg-gradient-to-br from-cyan-200/30 to-transparent rounded-full blur-3xl"></div>
            <div className="absolute bottom-20 right-20 w-80 h-80 bg-gradient-to-br from-teal-200/25 to-transparent rounded-full blur-3xl"></div>
          </div>
        </div>
        
        <div className="relative container mx-auto px-6 py-20">
          <div className="text-center max-w-4xl mx-auto">
            <Button onClick={() => navigate('/')} className="mb-8 bg-blue-600/80 hover:bg-blue-700/80 text-white border border-blue-500/50 font-medium px-6 py-3 rounded-xl shadow-lg">
              <ArrowRight className="w-4 h-4 mr-2" />
              חזרה לדף הבית
            </Button>
            
            <h1 className="text-4xl md:text-6xl font-bold text-blue-900 leading-tight mb-6">
              פרסים, הוקרה והסמכות
            </h1>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-6 py-16">
        <Card className="max-w-4xl mx-auto bg-white/80 backdrop-blur-md border border-white/50 shadow-2xl rounded-3xl">
          <CardContent className="p-8">
            <div className="text-right text-lg leading-relaxed text-slate-700 font-rounded" style={{
            fontFamily: 'system-ui, -apple-system, sans-serif'
          }}>
              <p className="mb-8">בדף זה מרוכזות תעודות הוקרה על תהליכים חינוכיים וארגונים בית- ספריים.</p>
              
              {/* PDF Certificate Card */}
              <div className="bg-blue-50 border-2 border-blue-200 rounded-2xl p-6 mt-6">
                <p className="text-right text-base leading-relaxed text-blue-900 font-medium mb-4">
                  תעודת ההצטיינות שהוענקה לבית הספר בשל תהליך מערכתי חינוכי-ערכי בתחום החינוך לבטיחות בדרכים (תשע״ב, 2012).
                </p>
                
                {/* PDF View Button */}
                <div className="flex justify-center mt-4">
                <a href="https://drive.google.com/file/d/10ZKICdFe9-Wadm3hBuEFLMe1Wlg_mXD-/preview" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 px-8 py-4 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-medium rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 cursor-pointer">
                  <FileText className="w-5 h-5" />
                  <span className="text-lg">לצפייה בתוצר (PDF)</span>
                </a>
              </div>
              </div>
              
              {/* Second PDF Certificate Card - Violet Theme */}
              <div className="bg-violet-50 border-2 border-violet-200 rounded-2xl p-6 mt-6">
                <p className="text-right text-base leading-relaxed text-violet-900 font-medium mb-4">
                  תעודת ההוקרה שהוענקה לבית הספר בשל תהליך עומק להטמעת ערכי ההכלה והסובלנות באקלים הבית ספרי (תשע"ה, ינואר 2015).
                </p>
                
                {/* PDF View Button */}
                <div className="flex justify-center mt-4">
                  <a href="https://drive.google.com/file/d/1DSnx3aVruSIwnB9fE_MEcoMAWBAPvLQ-/preview" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 px-8 py-4 bg-gradient-to-r from-violet-600 to-violet-700 hover:from-violet-700 hover:to-violet-800 text-white font-medium rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 cursor-pointer">
                    <FileText className="w-5 h-5" />
                    <span className="text-lg">לצפייה בתוצר (PDF)</span>
                  </a>
                </div>
              </div>
              
              {/* Third PDF Certificate Card - Green Theme */}
              <div className="bg-teal-50 border-2 border-teal-200 rounded-2xl p-6 mt-6">
                <p className="text-right text-base leading-relaxed text-teal-900 font-medium mb-4">תעודת הסמכה כבית ספר ירוק, שהוענקה לבית הספר בשל עשייה בתחום החינוך הסביבתי (תשע"ה, יוני 2015).</p>
                
                {/* PDF View Button */}
                <div className="flex justify-center mt-4">
                  <a href="https://drive.google.com/file/d/1fpn2PDBKMM3SfNoYnS2Az-6HRMcEuAVz/preview" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 px-8 py-4 bg-gradient-to-r from-teal-600 to-teal-700 hover:from-teal-700 hover:to-teal-800 text-white font-medium rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 cursor-pointer">
                    <FileText className="w-5 h-5" />
                    <span className="text-lg">לצפייה בתוצר (PDF)</span>
                  </a>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>;
};
export default Awards;